import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=5d15d738&scoped=true&"
import script from "./Return.vue?vue&type=script&lang=js&"
export * from "./Return.vue?vue&type=script&lang=js&"
import style0 from "./Return.vue?vue&type=style&index=0&id=5d15d738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15d738",
  null
  
)

export default component.exports